import React from "react";
import ActivitiesCalendar from "../activities/ActivitiesCalendar";

function ScheduleFollowupView({ companyName, contactName, lead, company, role, embedded = false }) {
  return (
    <ActivitiesCalendar
      company={company || { name: companyName }}
      lead={lead || { contactName }}
      role={role}
      embedded={embedded}
    />
  );
}

export default ScheduleFollowupView;

